export class SingleValueSelectedForFilterRule {
    filterKey;
    constructor(filterKey) {
        this.filterKey = filterKey;
    }
    getName() {
        return `SingleValueSelectedForFilterRule-${this.filterKey}`;
    }
    async forSearch(dependencies) {
        const seoInfoBase = dependencies.seoInfoBase;
        const filterState = dependencies.filterState;
        return await seoInfoBase.singleSelectionFor(this.filterKey, filterState);
    }
    forSitemapGenerator(filterKeyValues) {
        const filterValues = filterKeyValues.get(this.filterKey);
        if (!filterValues || filterValues.length !== 1) {
            return Promise.resolve(false);
        }
        return Promise.resolve(true);
    }
}
